<template>
  <div v-scroll="onScroll" class="ol-my-md full-menu" :class="classes">
    <div class="full-menu-search search base-border-radius flex no-wrap items-center">
      <div
        id="menu-btn_search"
        class="provider-block provider-block_search items-center no-wrap cursor-pointer ol-px-sm"
        :class="{ 'cas-secondary': selectedManufacturersSlugs.length }"
        @click="openSearchModal"
      >
        <Icon class="provider-block__icon" name="search" />
        <p>{{ $t('search') }}</p>
      </div>

      <div
        id="menu-btn_providers"
        class="provider-block provider-block_providers items-center no-wrap cursor-pointer ol-px-sm"
        :class="{ 'cas-secondary': selectedManufacturersSlugs.length }"
        @click="openSearchProvidersModal"
      >
        <Icon class="provider-block__icon" name="filter" />
        <p>{{ $t('providers') }}</p>
      </div>

      <!-- TODO: Изменить логику отображения после реализации страницы "Избранное" -->
      <app-link
        v-if="getAuth"
        :to="{ name: 'Favorites' }"
        class="provider-block provider-block--favorites items-center no-wrap cursor-pointer"
        :class="{ 'cas-secondary': selectedManufacturersSlugs.length }"
      >
        <Icon class="provider-block__icon" name="favorites-outline" />
        <span v-if="favoritesCount" class="provider-block__counter">
          {{ favoritesCount > 99 ? '99+' : favoritesCount }}
        </span>
        <p>{{ $t('favorites') }}</p>
      </app-link>
    </div>
    <div class="main-menu-wrap full-width">
      <div class="main-menu-wrap__fixed-block" :class="[`main-menu-wrap__fixed-block_scroll-${scrollGamesMenu}`]">
        <games-menu
          class="full-menu__groups full-width"
          :is-sticky="fullMenuIsSticky"
          @change-scroll="scrollGamesMenu = $event"
        />
      </div>
      <q-resize-observer @resize="onResize" />
    </div>
  </div>
</template>

<script>
import GamesMenu from 'components/games/GamesMenu'
import { mapActions, mapGetters } from 'vuex'
import { defineAsyncComponent } from 'vue'
import { markRaw } from 'vue'
import getFavoritesCountGql from 'src/apollo/queries/getFavoritesCount.gql'

export default {
  name: 'FullMenu',
  components: { GamesMenu },
  inject: ['appModal'],
  data() {
    return {
      searchModal: false,
      scrollGamesMenu: 'start',
      isStickyHeader: false,
      fullMenuIsSticky: false,
    }
  },
  computed: {
    ...mapGetters(['getAuth', 'favoritesCount', 'getIsAlt', 'isWebView']),
    ...mapGetters({ mainGroups: 'getMainGroups' }),
    classes() {
      return [
        { 'full-menu--sticky': this.fullMenuIsSticky },
        { 'full-menu--sticky-alt-webview': this.getIsAlt && this.isWebView },
      ]
    },
    selectedManufacturersSlugs() {
      return this.$route.query.manufacturer ? this.$route.query.manufacturer.split(',') : []
    },
  },
  mounted() {
    document.addEventListener('scroll', this.onScroll)
    this.getFavoritesGamesCount()
  },
  beforeUnmount() {
    document.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    ...mapActions(['updateFavoritesCount']),
    openSearchModal() {
      this.appModal.open({
        componentName: markRaw(defineAsyncComponent(() => import('src/components/search/SearchModal.vue'))),
        isBigSize: true,
      })
    },
    openSearchProvidersModal() {
      this.appModal.open({
        componentName: markRaw(
          defineAsyncComponent(() => import('components/providers/filter/SearchProvidersGames.vue'))
        ),
        isBigSize: true,
      })
    },
    onResize() {
      this.fullMenuIsSticky = false
    },
    onScroll() {
      if (window.innerWidth <= 575) {
        const mainSlider = document.querySelector('.main-slider')
        let offsetTop = 0
        let offsetHeight = 0

        if (!mainSlider) {
          this.fullMenuIsSticky = true
          return
        }

        if (this.isWebView && this.getIsAlt) {
          const menuBlock = document.querySelector('.tabs-web-view')
          if (menuBlock) {
            offsetTop -= menuBlock.offsetTop
            offsetHeight -= menuBlock.offsetHeight
          }
        }

        offsetTop += mainSlider.offsetTop
        offsetHeight += mainSlider.offsetHeight

        const position = window.scrollY
        const threshold = offsetTop + offsetHeight

        if (position >= threshold && this.$route.name !== 'Home') {
          this.fullMenuIsSticky = true
        } else {
          this.fullMenuIsSticky = false
        }
      }
    },
    getFavoritesGamesCount() {
      if (this.favoritesCount !== null || !this.getAuth) {
        return
      }
      this.$apollo
        .query({
          query: getFavoritesCountGql,
        })
        .then(({ data }) => {
          this.updateFavoritesCount(data.currentUser.favorites.totalCount)
        })
    },
  },
}
</script>

<style lang="scss">
.full-menu {
  .group {
    will-change: padding;
    transition: 0.1s linear;
  }

  .group__txt {
    will-change: font-size;
    transition: 0.1s linear;
  }

  .group-wrap {
    will-change: height;
    transition: 0.1s linear;
  }

  &--sticky {
    position: sticky;
    top: 4px;
    background: var(--cas-main-opacity-80);
    backdrop-filter: blur(1px);
    z-index: 2;

    .group-wrap {
      height: 48px !important;
    }

    .group {
      padding: 5px 5px !important;
    }

    .group__txt {
      font-size: 0 !important;
    }

    // .main-menu-wrap {
    //   height: 48px;
    // }
  }

  &--sticky-alt-webview {
    top: 53px;
  }
}

.provider-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 8px;
  width: 100px;
  height: 100%;
  background: rgba(255, 255, 255, 0.07);
  border-radius: var(--radius-radius-card, 4px);
  text-decoration: none;

  &__icon {
    height: 32px;
    width: 32px;
    color: #fff;
    transition: 0.16s;
  }

  p {
    font-size: 14px;
    opacity: 0.7;
    transition: 0.16s;
    color: #fff;
  }

  &__counter {
    position: absolute;
    min-width: 14px;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    font-size: 10px;
    font-weight: 800;
    color: #151642;
    outline: 2px solid #151642;
    border-radius: 8px;
    top: 9px;
    left: 56px;
    padding: 3px 4px;
    transition: 0.16s;
  }

  &--favorites {
    position: relative;
  }

  &:hover {
    .provider-block__icon {
      color: #f6a913;
    }

    .provider-block__counter {
      background: #f6a913;
    }

    p {
      color: #f6a913;
    }
  }

  @media (max-width: 1023px) {
    min-width: 80px;
    height: 40px;
    &__counter {
      top: 6px;
      left: 46px;
    }
    p {
      display: none;
    }

    &_search {
      flex-direction: row;
      justify-content: flex-start;
      column-gap: 12px;
      width: 100%;

      p {
        display: block;
      }
    }

    &__icon {
      height: 24px;
      width: 24px;
    }
  }
}

.full-menu {
  display: flex;
  row-gap: 8px;
  height: 80px;
  transition: 0.3s;

  @media (max-width: 1023px) {
    flex-direction: column;
    height: auto;
  }

  @media (max-width: 767px) {
    row-gap: 6px;
  }

  &__separator {
    @media (max-width: 575px) {
      margin: 0;
    }
  }

  &__groups {
    @media (max-width: 575px) {
      width: 100%;
    }
  }
}

.main-menu-wrap {
  overflow: hidden;
}

.search {
  gap: 8px;
  margin-right: 8px;

  @media (max-width: 1023px) {
    margin-right: 0;
    width: 100%;
  }

  @media (max-width: 767px) {
    gap: 6px;
  }
}

.search-block {
  @media (max-width: 575px) {
    justify-content: flex-start;
    flex: 1 1;
    padding: 0 20px;
    width: auto;
  }

  &__text {
    @media (max-width: 575px) {
      display: block;
      font-size: 15px;
      margin-left: 12px;
    }
  }
}

.game-search__body {
  font-size: 16px;
  padding: 24px;
  overflow: auto;
  flex: 1 1;
  max-height: 50vh;

  p {
    margin-bottom: 1em;
  }

  @media (max-width: 768px) {
    max-height: none;
  }
}
</style>
